import {
  CircularProgress,
  FormControl,
  type FormControlProps,
  FormErrorMessage,
  FormLabel,
  type FormLabelProps,
  Input,
  InputGroup,
  type InputProps,
  InputRightElement
} from '@chakra-ui/react'
import { Controller, type ControllerProps } from 'react-hook-form'
import { type NshiftCheckoutFormValues } from './types'

export const NshiftFormFieldLabel = (props: FormLabelProps) => {
  return <FormLabel fontSize="sm" color="text.mild" {...props} />
}

interface NshiftFormFieldProps {
  name: keyof NshiftCheckoutFormValues
  label: string
  isLoading?: boolean
  formControlProps?: FormControlProps
  inputProps?: InputProps
  controllerProps?: Partial<ControllerProps>
}

export const NshiftFormField = ({
  name,
  label,
  isLoading,
  formControlProps,
  inputProps,
  controllerProps
}: NshiftFormFieldProps) => {
  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => (
        <FormControl {...formControlProps} isInvalid={fieldState.invalid}>
          <NshiftFormFieldLabel>{label}</NshiftFormFieldLabel>

          <InputGroup>
            <Input {...inputProps} {...field} placeholder={label} />
            {isLoading && (
              <InputRightElement>
                <CircularProgress isIndeterminate size="var(--input-font-size)" />
              </InputRightElement>
            )}
          </InputGroup>

          <FormErrorMessage>{fieldState.error?.message}</FormErrorMessage>
        </FormControl>
      )}
      {...controllerProps}
    />
  )
}
